export const item = {
  hidden: { scale: 0, opacity: 0 },
  show: {
    scale: 1,
    opacity: 1,
    transition: { duration: 0.3, type: "spring", stiffness: 60 },
  },
};
